import React from "react";

import { Box, Card, Skeleton } from "@mui/material";

import styles from "./cardItem.module.css";

const SkeletonCard: React.FunctionComponent = () => {
	return (
		<Card className={styles.card}>
			<Box sx={{ display: "flex", gap: "10px" }}>
				<Skeleton variant="rectangular" width={40} height={40} />
				<Skeleton variant="text" width={150} height={40} />
			</Box>
			<Skeleton
				className={styles.skeleton}
				variant="rectangular"
				height={130}
				sx={{ margin: "20px" }}
			/>
			<Skeleton
				className={styles.skeleton}
				variant="rectangular"
				height={250}
				sx={{ margin: "20px" }}
			/>
			<Box sx={{ display: "flex" }}>
				<Skeleton
					className={styles.skeleton}
					variant="rectangular"
					width={40}
					height={40}
					sx={{ marginLeft: "20px" }}
				/>
				<Skeleton
					className={styles.skeleton}
					variant="rectangular"
					width={40}
					height={40}
				/>
			</Box>
		</Card>
	);
};

export default SkeletonCard;
